exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\r\n.submitted .form-control.ng-invalid,\r\n.submitted .errorField,\r\n:host >>> .submitted .ng-invalid .ui-calendar .ui-inputtext,\r\n:host >>> .submitted .ng-invalid .ui-dropdown .ui-dropdown-label {\r\n    border-color: #DE6D31 !important;\r\n    background-color: #ffe7e7;\r\n    transition: .3s;\r\n}\r\n\r\n.container-form form {\r\n    border: 0px solid #ffffff;\r\n}\r\n\r\n.disabled{\r\n    cursor: not-allowed;\r\n    background-color: lightgrey;\r\n}\r\n\r\n.input-group{\r\n    width: 300px;\r\n}\r\n\r\n.button-submit-forgot{\r\n    margin-left: 5.7em;\r\n}\r\n\r\n.col-md-12{\r\n    padding: 0;\r\n}\r\n.col-md-4{\r\n    padding: 0;\r\n    width: 320px;\r\n}\r\n\r\n/* select{\r\n    font-family:Raleway,\"Helvetica Neue\",Helvetica,Arial,sans-serif ;\r\n} */\r\n\r\n\r\nselect, input, textarea{\r\n    /* font-family: Raleway,\"Helvetica Neue\",Helvetica,Arial,sans-serif !important; */\r\n    font-family: Roboto,Trebuchet MS,Arial,Helvetica,sans-serif;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/create-account/create-account.component.css
// module id = 1011
// module chunks = 1